/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentAdminControllerCancelStuckProcessingsMutationResponse, DocumentAdminControllerCancelStuckProcessings400, DocumentAdminControllerCancelStuckProcessings401, DocumentAdminControllerCancelStuckProcessings403 } from "../../models/documentAdminController/DocumentAdminControllerCancelStuckProcessings";

function getDocumentAdminControllerCancelStuckProcessingsUrl() {
  const res = { method: 'POST', url: `/api/v1/documents/stuck-processings/cancel` as const }  
  return res
}

/**
 * @description Admin/service-account endpoint. Drives each approved stuck processing to a terminal state: RUNNING steps fail with a PERMANENT error, other non-terminal steps are cancelled with an annotation, and the processing/document/file are finalized through the same path normal completion uses. processingIds restricts the run to an approved set; the server re-detects and acts only on the ones still stuck, reporting the rest as dropped. Rows whose job claims a live worker are skipped (reported separately) unless includeActiveWorkers is set. The response verifies that no attempted processings remain stuck.
 * @summary Cancel stuck processings and finalize their documents/files
 * {@link /api/v1/documents/stuck-processings/cancel}
 */
export async function documentAdminControllerCancelStuckProcessings(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentAdminControllerCancelStuckProcessingsMutationResponse, ResponseErrorConfig<DocumentAdminControllerCancelStuckProcessings400 | DocumentAdminControllerCancelStuckProcessings401 | DocumentAdminControllerCancelStuckProcessings403>, unknown>({ method : "POST", url : getDocumentAdminControllerCancelStuckProcessingsUrl().url.toString(), ... requestConfig })  
  return res.data
}